module.exports = __webpack_public_path__ + "static/mr-press-24-8c447b083dd86bd861653a7d8ae62667.jpg";